import api from './api';
import { LoginRequest, RegisterRequest, AuthResponse, User, OwnerListItem, ThemeMode } from '../types';

export const authService = {
  login: async (credentials: LoginRequest): Promise<AuthResponse> => {
    const response = await api.post<AuthResponse>('/auth/login', credentials);
    return response.data;
  },

  register: async (data: RegisterRequest): Promise<AuthResponse> => {
    const response = await api.post<AuthResponse>('/auth/register', data);
    return response.data;
  },

  logout: async (): Promise<void> => {
    await api.post('/auth/logout');
  },

  getCurrentUser: async (): Promise<User> => {
    const response = await api.get<User>('/auth/me');
    return response.data;
  },

  refreshToken: async (refreshToken: string): Promise<AuthResponse> => {
    const response = await api.post<AuthResponse>('/auth/refresh', {
      refresh_token: refreshToken,
    });
    return response.data;
  },

  getOwners: async (): Promise<OwnerListItem[]> => {
    const response = await api.get<OwnerListItem[]>('/auth/owners');
    return response.data;
  },

  updatePreferences: async (prefs: { theme?: ThemeMode }): Promise<User> => {
    const response = await api.patch<User>('/users/me/preferences', prefs);
    return response.data;
  },
};
